var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgStressfulSituation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96897 18.0005H6.28711V20.4551L9.96897 18.0005Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7158 13.0156H14.031L17.7158 15.4722V13.0156Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96897 18.0005H12.25C13.0023 18.0005 13.6252 17.4468 13.7334 16.7247M9.96897 18.0005H6.28711M9.96897 18.0005L6.28711 20.4551V18.0005M6.28711 18.0005H4.25C3.42157 18.0005 2.75 17.3289 2.75 16.5005V10.9844C2.75 10.1559 3.42157 9.48438 4.25 9.48438H7M19.75 4.5H11.75C10.9216 4.5 10.25 5.17157 10.25 6V11.5161C10.25 12.3446 10.9216 13.0161 11.75 13.0161H19.75C20.5784 13.0161 21.25 12.3446 21.25 11.5161V6C21.25 5.17157 20.5784 4.5 19.75 4.5ZM17.7158 15.4722V13.0156H14.031L17.7158 15.4722Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressfulSituation);
export default __webpack_public_path__ + "static/media/stressful-situation.44434ca58505f92110c777240f1a7447.svg";
export { ForwardRef as ReactComponent };